import { IconsSprite } from "@shared/ui/Icon/ui/types";
import { AsterKzIcon } from "./AsterKzIcon";
import { AutoRuIcon } from "./AutoRuIcon";
import { AvByIcon } from "./AvByIcon";
import { AvitoIcon } from "./AvitoIcon";
import { DromIcon } from "./DromIcon";
import { KolesaKzIcon } from "./KolesaKzIcon";
import { LikviIcon } from "./LikviIcon";
import { MigTorgBlackIcon } from "./MigTorgBlackIcon";
import { MobileDeIcon } from "./MobileDeIcon";
import { MyCarIcon } from "./MyCarIcon";
import { UremontIconBlack } from "./UremontIconBlack";

export const BoardsSprite: IconsSprite = {
    0: LikviIcon,
    1: DromIcon,
    2: AvitoIcon,
    3: AutoRuIcon,
    6: AsterKzIcon,
    7: MyCarIcon,
    8: KolesaKzIcon,
    9: MobileDeIcon,
    10: AvByIcon,
    11: UremontIconBlack,
    12: MigTorgBlackIcon
};